import React from 'react';
import clsx from 'clsx';
import { Button, Icon } from 'semantic-ui-react';
import { FormattedMessage, useIntl } from 'react-intl';

const IconButton = ({
  active,
  basic,
  circular,
  compact,
  className,
  dataPosition = 'left center',
  disabled,
  floated,
  href,
  icon,
  iconClassName,
  iconName,
  iconOnly,
  labelPosition = 'right',
  loading,
  messageId,
  negative,
  onClick,
  positive,
  primary,
  secondary,
  size,
  text,
  toggle,
  tooltip,
}) => {
  const intl = useIntl();
  const alt = tooltip || text || intl.formatMessage({ id: messageId });

  return (
    <Button
      active={active}
      as={href ? 'a' : undefined}
      basic={basic}
      circular={circular}
      compact={compact}
      className={clsx('aridhia-icon-button', className)}
      data-position={iconOnly ? dataPosition : undefined}
      data-tooltip={iconOnly ? alt : undefined}
      disabled={disabled}
      floated={floated}
      href={disabled ? undefined : href}
      icon={icon || !!iconName}
      labelPosition={iconOnly ? undefined : labelPosition}
      loading={loading}
      negative={negative}
      onClick={disabled ? undefined : onClick}
      positive={positive}
      secondary={secondary}
      primary={primary}
      size={size}
      toggle={toggle}
    >
      {labelPosition === 'left' && <Icon className={iconClassName} name={iconName} alt={alt} />}
      {!iconOnly && text && <>{text}</>}
      {!iconOnly && !text && <FormattedMessage id={messageId} />}
      {labelPosition !== 'left' && <Icon className={iconClassName} name={iconName} alt={alt} />}
    </Button>
  );
};

export default IconButton;
